module.exports = __webpack_public_path__ + "static/media/WhiteToken.e1974969.mp4";